import store from "../store";

export default {
  preventZoom(e) {
    // 禁止 Ctrl + 滚轮
    if (e.type === "wheel" && e.ctrlKey) {
      e.preventDefault();
    }

    // 禁止 Ctrl + "+"/"-"/"0"
    if (
      e.type === "keydown" &&
      e.ctrlKey &&
      (e.key === "+" || e.key === "-" || e.key === "=" || e.key === "0")
    ) {
      e.preventDefault();
    }

    // 禁止双指缩放（移动端）
    if (e.type === "gesturestart") {
      e.preventDefault();
    }
  },
  getPlatform() {
    let ua = navigator.userAgent;

    if (/android/i.test(ua)) {
      return "Android";
    }
    if (/iPhone|iPad|iPod/i.test(ua)) {
      return "iOS";
    }
    return "PC";
  },
  /**万亿转换 */
  transformSentimentCount(sentimentCount) {
    if (sentimentCount >= 10000 && sentimentCount < 100000000) {
      if ((sentimentCount / 10000) % 1 === 0) {
        return sentimentCount / 10000 + "万";
      } else {
        return (sentimentCount / 10000).toFixed(2) + "万";
      }
    } else if (sentimentCount >= 100000000) {
      if ((sentimentCount / 100000000) % 1 === 0) {
        return sentimentCount / 100000000 + "亿";
      } else {
        return (sentimentCount / 100000000).toFixed(2) + "亿";
      }
    } else {
      return sentimentCount;
    }
  },
  getLocalTime(nS) {
    let date = new Date(nS * 1000); //如果date为13位不需要乘1000
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    let h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    let m =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return Y + M + D + h + m;
  },
  /**
   *
   * @param {oem logo} key
   * @returns
   */
  get_system_logo(key = "logo-manyu") {
    const logoImages = {
      "logo-manyu": require("../assets/logo-manyu.png"),
      "logo-shenglianyun": require("../assets/logo-shenglianyun.png"),
      "logo-xinxixi": require("../assets/logo-xinxixi.png"),
      "logo-lao-bin": require("../assets/logo-lao-bin.png"),
      "logo-hk": require("../assets/logo-hk.png"),
    };

    return logoImages[key] || logoImages["logo-manyu"];
  },

  /**
   *
   * @param {oem logo} key
   * @returns
   */
  get_system_avatar_logo(key = "logo-manyu") {
    const logoImages = {
      "logo-manyu": require("../assets/logo-avatar_manyu.png"),
      "logo-shenglianyun": require("../assets/logo-avatar_shenglianyun.png"),
      "logo-xinxixi": require("../assets/logo-avatar_xinxi.png"),
      "logo-hk": require("../assets/logo-hk.png"),
    };

    return logoImages[key] || logoImages["logo-manyu"];
  },
  getModelName(inputName) {
    var model_name_map = {
      // "NinJa-Motion-1.0-fast": "即梦AI-视频生成3.0 Pro",
      // "NinJa-Motion-0.9-lite": "viduq2",
      // "NinJa-Vision-1.0-fast": "即梦AI-图片生成4.0",
      // "NinJa-Motion-0.9-fast": "viduq2-pro",
      // "NinJa-Motion-0.8-lite": "MiniMax-Hailuo-02",
      // "NinJa-Motion-0.8-fast": "MiniMax-Hailuo-2.3",
      // "NinJa-Motion-1.0-lite": "即梦AI-视频生成3.0",
      // "NinJa-Motion-1.5-pro": "doubao-seedance-1-5-pro",
      // "NinJa-Motion-2.0-pro": "doubao-seedance-2-0-260128",
      // vidu: "vidu",
      // 即梦: "即梦",

      "即梦AI-视频生成3.0 Pro": "ManyuTop-Motion-JMV3.0 Pro",
      "即梦AI-图片生成4.0": "ManyuTop-Vision-JMP4.0",
      "即梦AI-视频生成3.0": "ManyuTop-Motion-JMV3.0",
      "doubao-seedance-1-5-pro": "ManyuTop-Motion-SD1.5",
      "doubao-seedance-2-0-260128": "ManyuTop-Motion-SD2.0",
      NanoBanana: "ManyuTop-Vision-NB",
      NanoBanana2: "ManyuTop-Vision-NB2",
      NanoBanana_pro: "ManyuTop-Vision-NBP",
      "doubao-seedance-2-0-fast-260128": "ManyuTop-Motion-SD2.0-FAST",
      "NinJa-Motion-1.0-fast": "ManyuTop-Motion-JMV3.0 Pro",
      "NinJa-Vision-1.0-fast": "ManyuTop-Vision-JMP4.0",
      "NinJa-Motion-1.0-lite": "ManyuTop-Motion-JMV3.0",
      "NinJa-Motion-1.5-pro": "ManyuTop-Motion-SD1.5",
      "NinJa-Motion-2.0-pro": "ManyuTop-Motion-SD2.0",
    };

    var model_names_map = {
      // "即梦AI-视频生成3.0 Pro": "NinJa-Motion-1.0-fast",
      // viduq2: "NinJa-Motion-0.9-lite",
      // "即梦AI-图片生成4.0": "NinJa-Vision-1.0-fast",
      // "viduq2-pro": "NinJa-Motion-0.9-fast",
      // "MiniMax-Hailuo-02": "NinJa-Motion-0.8-lite",
      // "MiniMax-Hailuo-2.3": "NinJa-Motion-0.8-fast",
      // "即梦AI-视频生成3.0": "NinJa-Motion-1.0-lite",
      // vidu: "vidu",
      // 即梦: "即梦",

      "即梦AI-视频生成3.0 Pro": "ManyuTop-Motion-JMV3.0 Pro",
      "即梦AI-图片生成4.0": "ManyuTop-Vision-JMP4.0",
      "即梦AI-视频生成3.0": "ManyuTop-Motion-JMV3.0",
      "doubao-seedance-1-5-pro": "ManyuTop-Motion-SD1.5",
      "doubao-seedance-2-0-260128": "ManyuTop-Motion-SD2.0",
      NanoBanana: "ManyuTop-Vision-NB",
      NanoBanana2: "ManyuTop-Vision-NB2",
      NanoBanana_pro: "ManyuTop-Vision-NBP",
      "doubao-seedance-2-0-fast-260128": "ManyuTop-Motion-SD2.0-FAST",
    };
    var versionName = store.state.versionName;
    if (versionName === "name") {
      return model_name_map[inputName] || inputName;
    }
    if (versionName === "names") {
      return model_names_map[inputName] || inputName;
    }
    return inputName;
  },
};
